if (!customElements.get('two-pm-ingredients')) {
  customElements.define(
    'two-pm-ingredients',
    class TwoPmIngredients extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-ingredient-category]')).filter((element) => element.matches('button'));
        this.slides = Array.from(this.querySelectorAll('.two-pm-ingredients__slide'));
        this.loadMoreButton = this.querySelector('[data-load-more]');
        this.slider = this.querySelector('.two-pm-ingredients__slider');
        this.tabsSlider = this.querySelector('.two-pm-ingredients__tabs-slider');
        this.tabsPaginationButtons = Array.from(this.querySelectorAll('[data-tabs-pagination-index]'));
        this.tabsWrap = this.querySelector('.two-pm-ingredients__tabs-wrap');
        this.content = this.querySelector('.two-pm-ingredients__content');
        this.activeCategory = 'all';
        this.showAll = false;
        this.mobileVisibleCount = Number(this.dataset.mobileVisibleCount) || 3;
        this.onTabClick = this.onTabClick.bind(this);
        this.onTabsSliderInitialized = this.onTabsSliderInitialized.bind(this);
        this.onTabsSliderChange = this.onTabsSliderChange.bind(this);
        this.onTabsPaginationClick = this.onTabsPaginationClick.bind(this);
        this.onLoadMore = this.onLoadMore.bind(this);
        this.syncStickyTabs = this.syncStickyTabs.bind(this);

        if (this.tabsWrap) {
          this.tabsPlaceholder = document.createElement('div');
          this.tabsPlaceholder.className = 'two-pm-ingredients__tabs-placeholder';
          this.tabsWrap.before(this.tabsPlaceholder);
          window.addEventListener('scroll', this.syncStickyTabs, { passive: true });
          window.addEventListener('resize', this.syncStickyTabs);
        }

        this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick));
        this.tabsPaginationButtons.forEach((button) => button.addEventListener('click', this.onTabsPaginationClick));
        this.tabsSlider?.addEventListener('swiper:initialized', this.onTabsSliderInitialized);
        this.onTabsSliderInitialized();
        this.loadMoreButton?.addEventListener('click', this.onLoadMore);
        this.updateCards();
        this.syncStickyTabs();
      }

      disconnectedCallback() {
        this.tabs?.forEach((tab) => tab.removeEventListener('click', this.onTabClick));
        this.tabsPaginationButtons?.forEach((button) => button.removeEventListener('click', this.onTabsPaginationClick));
        this.tabsSlider?.removeEventListener('swiper:initialized', this.onTabsSliderInitialized);
        this.tabsSlider?.swiper?.off('slideChange', this.onTabsSliderChange);
        this.loadMoreButton?.removeEventListener('click', this.onLoadMore);
        window.removeEventListener('scroll', this.syncStickyTabs);
        window.removeEventListener('resize', this.syncStickyTabs);
        this.clearStickyTabs();
        this.tabsPlaceholder?.remove();
      }

      onTabClick(event) {
        const tab = event.currentTarget;
        this.selectTab(tab, true);

        if (this.tabsSlider?.swiper) {
          this.tabsSlider.swiper.slideTo(this.tabs.indexOf(tab));
        }
      }

      onTabsSliderInitialized() {
        if (!this.tabsSlider?.swiper || this.tabsSliderSwiper === this.tabsSlider.swiper) return;

        this.tabsSliderSwiper?.off('slideChange', this.onTabsSliderChange);
        this.tabsSliderSwiper = this.tabsSlider.swiper;
        this.tabsSliderSwiper.on('slideChange', this.onTabsSliderChange);
      }

      onTabsPaginationClick(event) {
        const index = Number(event.currentTarget.dataset.tabsPaginationIndex);
        const tab = this.tabs[index];
        if (!tab) return;

        this.selectTab(tab, true);
        this.tabsSlider?.swiper?.slideTo(index);
      }

      onTabsSliderChange() {
        const index = this.tabsSliderSwiper?.realIndex;
        const tab = this.tabs[index];
        if (!tab) {
          this.tabsSliderSwiper?.slideTo(this.tabs.length - 1, 0);
          return;
        }

        this.selectTab(tab, false);
      }

      selectTab(tab, scrollToCard) {
        this.activeCategory = tab.dataset.ingredientCategory;
        this.showAll = false;
        this.updateCards();

        const description = this.querySelector('[data-category-description]');
        if (description) description.textContent = tab.dataset.ingredientDescription || '';

        this.tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', String(isActive));
        });

        this.tabsPaginationButtons.forEach((button, index) => {
          button.classList.toggle('swiper-pagination-bullet-active', this.tabs[index] === tab);
        });

        if (scrollToCard) this.scrollToFirstCard();
      }

      onLoadMore() {
        this.showAll = true;
        this.updateCards();
      }

      scrollToFirstCard() {
        if (window.innerWidth >= 768) return;

        const firstCard = this.querySelector('.two-pm-ingredients__slide.is-filtered-in.is-mobile-visible');
        if (!firstCard) return;

        const tabsHeight = this.tabsWrap?.offsetHeight || 0;
        const targetTop = firstCard.getBoundingClientRect().top + window.scrollY - tabsHeight - 12;

        window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
      }

      syncStickyTabs() {
        if (!this.tabsWrap || !this.content || window.innerWidth >= 768) {
          this.clearStickyTabs();
          return;
        }

        const tabsHeight = this.tabsWrap.offsetHeight;
        const contentRect = this.content.getBoundingClientRect();
        const anchorRect = this.tabsPlaceholder?.classList.contains('is-active')
          ? this.tabsPlaceholder.getBoundingClientRect()
          : this.tabsWrap.getBoundingClientRect();
        const shouldFix = anchorRect.top <= 0 && contentRect.bottom > tabsHeight;

        if (!shouldFix) {
          this.clearStickyTabs();
          return;
        }

        this.tabsPlaceholder.style.height = `${tabsHeight}px`;
        this.tabsPlaceholder.classList.add('is-active');
        this.tabsWrap.classList.add('is-fixed');

        const placeholderRect = this.tabsPlaceholder.getBoundingClientRect();
        this.tabsWrap.style.left = `${placeholderRect.left}px`;
        this.tabsWrap.style.width = `${placeholderRect.width}px`;
      }

      clearStickyTabs() {
        if (!this.tabsWrap) return;

        this.tabsWrap.classList.remove('is-fixed');
        this.tabsWrap.style.removeProperty('left');
        this.tabsWrap.style.removeProperty('width');
        this.tabsPlaceholder?.classList.remove('is-active');
        this.tabsPlaceholder?.style.removeProperty('height');
      }

      updateCards() {
        const visibleSlides = this.slides.filter((slide) => {
          return this.activeCategory === 'all' || slide.dataset.ingredientCategory === this.activeCategory;
        });

        this.classList.toggle('is-showing-all', this.showAll);

        this.slides.forEach((slide) => {
          const index = visibleSlides.indexOf(slide);
          const isVisible = index !== -1;
          const isMobileVisible = isVisible && (this.showAll || index < this.mobileVisibleCount);
          slide.classList.toggle('is-filtered-in', isVisible);
          slide.classList.toggle('is-mobile-visible', isMobileVisible);
          slide.hidden = !isVisible;
        });

        if (this.loadMoreButton) {
          this.loadMoreButton.hidden = this.showAll || visibleSlides.length <= this.mobileVisibleCount;
        }

        if (this.slider?.swiper) {
          this.slider.swiper.update();
          this.slider.swiper.slideTo(0, 0);
        }

        this.syncStickyTabs();
      }
    }
  );
}
